// extracted by mini-css-extract-plugin
export default {"captcha":"GLkdR","reset":"q3Wab"};